(function () {
  window.addEventListener("message", function (event) {
    var data = event.data;
    if (!data || data.source !== "nato-concept-configurator") return;

    if (data.type === "ADD_TO_CART") {
      var payload = data.payload;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: payload.variantId,
              quantity: payload.quantity || 1,
              properties: payload.properties,
            },
          ],
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Sepete ekleme basarisiz");
          return res.json();
        })
        .then(function () {
          var modal = document.getElementById("nato-configurator-modal");
          if (modal) modal.style.display = "none";
          window.location.href = "/cart";
        })
        .catch(function (err) {
          console.error("Nato Concept configurator sepete ekleme hatasi:", err);
          alert("Sepete eklerken bir sorun olustu, lutfen tekrar deneyin.");
        });
    }
  });
})();